import { useEffect } from "react";
import { toast } from "react-toastify";

import { useQuery } from "@tanstack/react-query";

import useFetch, { CacheTime } from "../../../utils/hooks/useFetch.ts";
import { Urls } from "../../urls.ts";

import { AvailableDatesApiResponse } from "./type.ts";

type useAvailableDatesParams = {
  hallId?: string | null;
};

const useAvailableDates = (params: useAvailableDatesParams) => {
  const { hallId } = params;

  const fetch = useFetch();

  const { data, isLoading, isError, error } = useQuery<
    AvailableDatesApiResponse | null,
    Error,
    AvailableDatesApiResponse
  >({
    queryKey: ["available-dates"],
    enabled: !!hallId,
    queryFn: () =>
      fetch<AvailableDatesApiResponse>(`${Urls.AvailableDates}`, {
        method: "GET",
        slug: {
          hallId,
        },
      }),
    refetchInterval: CacheTime,
    gcTime: CacheTime,
    staleTime: CacheTime,
  });

  useEffect(() => {
    if (isError) {
      toast.error(error?.message || "Error getting available dates");
    }
  }, [error?.message, isError]);

  return {
    availableDates: data?.bookingDates || [],
    isFetching: isLoading,
  };
};

export default useAvailableDates;
